import { render, staticRenderFns } from "./WorkflowContur.vue?vue&type=template&id=0dec0a44"
import script from "./WorkflowContur.vue?vue&type=script&lang=js"
export * from "./WorkflowContur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports